import { Helmet } from 'react-helmet-async';

import { PageHeader } from '@ant-design/pro-components';

import ReminderLetterContent from '../ReminderLetterContent';

const ReminderLetter2Listing = () => {
  return (
    <>
      <Helmet>
        <title>Reminder Letter 2 - RedCash Collection</title>
      </Helmet>
      <PageHeader className="px-0 mb-2" title="Reminder Letter 2" />
      <ReminderLetterContent letterNumber="2" />
    </>
  );
};

export default ReminderLetter2Listing;
